import { render, staticRenderFns } from "./SingleSignOnRouter.vue?vue&type=template&id=b401ae9c&scoped=true&"
import script from "./SingleSignOnRouter.vue?vue&type=script&lang=js&"
export * from "./SingleSignOnRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b401ae9c",
  null
  
)

export default component.exports